import { useMutation, useQuery } from "react-query"
import { apiClient } from "../apiClient/apiService"
import ApiEndpoints, { API_END_POINT, ROUTES } from "../apiClient/apiEndpoints"
import { useLocalStorage, useReadLocalStorage } from "usehooks-ts"
import { useRouter } from "next/navigation"
import { toast } from "react-toastify"
import { UserDetails } from "../../interface/UserDetails"
import { getAnalytics, setUserId } from "firebase/analytics"

interface IFormData {
  email_id: string
  password: string
}
interface ILoginResponse {
  token: string
}
interface UseLoginMutationProps {
  onError?: (error: string) => void // Callback function for handling errors
}

const useLoginMutation = (props?: UseLoginMutationProps) => {
  const [_, setAccessToken] = useLocalStorage("accessToken", "")
  const [__, setUser] = useLocalStorage("userData", {})

  const router = useRouter()

  const getUserDetailsMutation = useMutation({
    mutationFn: (data) => {
      return apiClient.get(`${API_END_POINT.GET[ROUTES.getUserDetails]}`)
    },
  })

  return useMutation({
    mutationFn: (data: IFormData) => {
      return apiClient.post<IFormData, ILoginResponse>(ApiEndpoints.POST[ROUTES.login], data)
    },
    onSuccess: async (data) => {
      if (data?.token) {
        setAccessToken(data.token)
        apiClient.setAccessToken(data.token)

        getUserDetailsMutation.mutate(undefined, {
          onSuccess: (data: any) => {
            setUser(data.data.data)
            toast.success("Login Successful!", { position: "top-right" })
            router.push("/arrival-departure")
            const analytics = getAnalytics()
            if (analytics) setUserId(analytics, data.data.data.id.toString())
          },
        })
      }
    },
    onError: (error: any) => {
      const errorMessage = "Invalid User" // Default error message
      if (props?.onError) {
        props.onError(errorMessage)
      }
    },
  })
}

export default useLoginMutation
